export default __webpack_public_path__ + "static/icon-akun-2f6389d5177bff67debf0e5e4ef56018.png";